const COTTON_PATH = '/cotton-shield';
const COTTON_APIS_V1 = `${COTTON_PATH}/apis/v1`;
const COTTON_APIS = `${COTTON_PATH}/apis`;
const encode = window.encodeURIComponent;

// Kotlin has no Session API; session validation uses Python's oauth/validate.
// Kept relative so the fetch is same-origin and the dev proxy routes it to Python.
export const COTTON_OAUTH_CALLBACK = `${COTTON_PATH}/oauth/callback`;
export const COTTON_OAUTH_VALIDATE = `${COTTON_PATH}/oauth/validate`;
export const COTTON_V1_DISCONNECT = `${COTTON_PATH}/oauth/v1/disconnect`;
export const COTTON_V1_FORCE_CONNECT = `${COTTON_PATH}/oauth/v1/force_connect`;
export const COTTON_V1_PASSIVE_CONNECT = `${COTTON_PATH}/oauth/v1/passive_connect`;
export const COTTON_DISCONNECT = `${COTTON_PATH}/oauth/disconnect`;
export const COTTON_MACAROON = `${COTTON_APIS_V1}/macaroon`;
export const COTTON_SSM_USER = `${COTTON_APIS_V1}/ssm/user`;
export const COTTON_BILL = `${COTTON_APIS_V1}/bill/current`;
export const COTTON_BILL_DELINQUENCY = `${COTTON_APIS_V1}/bill/delinquency`;
export const COTTON_CHANNEL_DATA = `${COTTON_APIS_V1}/channel-data`;
export const COTTON_ACCEPTED_CONTRACTS = `${COTTON_APIS_V1}/contracts/accepted-contracts`;
export const COTTON_ACCEPT_AUTOPAY_CONTRACT_URL = `${COTTON_APIS_V1}/contracts/autopay`;
export const COTTON_SSM_STEP_UP = `${COTTON_APIS_V1}/ssm/step-up/add-instrument`;
export const COTTON_SSM_NOW_WALLET_INSTRUMENTS = `${COTTON_APIS_V1}/ssm/now/wallet/instruments`;
export const COTTON_ACCOUNT_COLLECTIONS_2 = `${COTTON_APIS_V1}/account?xap=true&ltip=true&productClasses=NOW`;
export const COTTON_MOVE_BILL_DUE_DATE = `${COTTON_APIS_V1}/ssm/bill/duedates`;
export const COTTON_CMS_SEGMENTS = `${COTTON_APIS_V1}/ssm/segments?tags=digitalselfservice,peacock`;
export const COTTON_CONTRACT_TERMS = contractId => `${COTTON_APIS_V1}/contracts/terms/${contractId}`;
export const COTTON_BILL_DATA = `${COTTON_APIS_V1}/ssm/bill/data`;
export const COTTON_ARRANGEMENT = `${COTTON_APIS_V1}/ssm/bill/plans/arrangement`;
export const COTTON_SSM_CONTEXT_HUB = events => `${COTTON_APIS_V1}/ssm/context?events=${encode(events)}`;
export const COTTON_SSM_AUTOPAY = `${COTTON_APIS_V1}/ssm/payment/autopay`;
export const COTTON_SSM_BILL_FUTURE_STATEMENT = `${COTTON_APIS_V1}/ssm/bill/statement/future`;
export const COTTON_SSM_NOW_UPDATE_PAYMENT = `${COTTON_APIS_V1}/ssm/now/autopay/update/method`;
export const COTTON_SSM_XM_CUSTOMER_ACCOUNT = `${COTTON_APIS_V1}/ssm/xm/ordertech/account`;
export const COTTON_SSM_XM_ESTIMATED = `${COTTON_APIS_V1}/ssm/xm/estimated`;

export const COTTON_SSM_FLEXIBLE_OPTIONS = `${COTTON_APIS_V1}/ssm/flexibleOptions`;

export const COTTON_AUTOPAY = `${COTTON_APIS}/autopay`;
export const COTTON_AUTOPAY_V4 = `${COTTON_APIS}/autopay-v4`;
export const COTTON_LATE_FEE_CREDIT = `${COTTON_APIS}/latefeecredit/read`;
export const COTTON_LATE_FEE_CREDIT_ENROLL = `${COTTON_APIS}/latefeecredit/enroll`;
const COTTON_PAYMENT_PLAN_BASE = `${COTTON_APIS}/csp/account/me/xap/exit/options`;
export const cottonPaymentPlan = otherPaymentAmount => (
  otherPaymentAmount
    ? `${COTTON_PAYMENT_PLAN_BASE}?otherPaymentAmount=${encode(otherPaymentAmount)}`
    : COTTON_PAYMENT_PLAN_BASE
);
const COTTON_PAYMENT_PLAN_LTIP_BASE = `${COTTON_APIS}/csp/account/me/ltip/options`;
export const cottonPaymentPlanLtip = otherPaymentAmount => (
  otherPaymentAmount
    ? `${COTTON_PAYMENT_PLAN_LTIP_BASE}?otherPaymentAmount=${encode(otherPaymentAmount)}`
    : COTTON_PAYMENT_PLAN_LTIP_BASE
);
export const COTTON_INTERNET_TIER = `${COTTON_APIS}/csp/account/me/services/internet/plan`;

// Consent APIs
export const COTTON_CONSENT = {
  REGISTER: consentId => `${COTTON_APIS}/consent/register?consentId=${encode(consentId)}`,
  RESOLVE: crsId => `${COTTON_APIS}/consent/resolve?crsId=${encode(crsId)}`,
  GET_BILL_INFO: `${COTTON_APIS}/consent/bill-info`,
};

export const COTTON_COLLECTIONS_OFFER = consentId => `${COTTON_APIS}/csp/account/me/order/summary?consentId=${consentId}`;
export const COTTON_ENROLL_INSTALLMENT_PLAN = `${COTTON_APIS}/csp/account/me/ltip`;
export const COTTON_PAYMENT_PLAN_SIGNUP = `${COTTON_APIS}/csp/account/me/xap/exit`;
export const COTTON_CONVOY_INDICATORS = accNum => `${COTTON_APIS}/convoy/account/${accNum}/indicators`;
export const COTTON_CHANNEL_TRACKING_URL = `${COTTON_APIS}/channel-tracking`;
export const COTTON_ONE_TIME_PAY = `${COTTON_APIS}/payments/one-time-v4`;
export const COTTON_SCHEDULED_PAYMENTS = `${COTTON_APIS}/payments/scheduled`;
export const COTTON_SCHEDULED_PAY = `${COTTON_APIS}/payments/scheduled/add-v4`;
export const COTTON_PAYMENT_INSTRUMENTS = `${COTTON_APIS}/payments/instruments-v4`;
export const COTTON_DELETE_INSTRUMENT_URL = `${COTTON_APIS}/payments/delete`;
export const COTTON_UPDATE_INSTRUMENT_URL = `${COTTON_APIS}/payments/updateInstrument`;
export const COTTON_CANCEL_SCHEDULED_PAYMENT_URL = `${COTTON_APIS}/payments/scheduled/cancel`;
export const COTTON_OT_LINES = `${COTTON_APIS}/ot/account/lines`;
export const COTTON_OT_PAYMENT_TRANSACTIONS = (accountId, state) => `${COTTON_APIS}/ot/accounts/${accountId}/payment/transactions?state=${state}`;
export const COTTON_OT_HOP_INITIALIZATION = `${COTTON_APIS}/ot/customer/account/payment/hop/initialization?isXMMyAccount=true&isCpc=true`;
export const COTTON_OT_CURRENT_PAYMENT_INSTRUMENT = `${COTTON_APIS}/ot/account/paymentinstrument`;
export const COTTON_OT_MAKE_PAYMENT = `${COTTON_APIS}/ot/account/payment`;
export const COTTON_OT_PAST_DUE_PAYMENT = `${COTTON_APIS}/ot/account/pastduepayment`;
export const COTTON_OT_MAKE_DEVICE_PAYMENT = dppId => `${COTTON_APIS}/ot/dpps/${dppId}/payment`;
export const COTTON_ACCEPT_ECOBILL_CONTRACT_URL = `${COTTON_APIS}/contracts/terms/ecobill`;
export const COTTON_ACCEPT_INSTRUMENT_CONTRACT_URL = `${COTTON_APIS}/contracts/terms/stored-payment`;
export const COTTON_STEP_UP = `${COTTON_APIS}/step-up/add-instrument`;
